import { serverFetch } from "@core/server";

export function fetchSprHolidays(year) {
  return serverFetch("sprs/holidays", {
    queryParams: { year }
  });
}

export function setSprHoliday(fdate) {
  return serverFetch("sprs/holidays", {
    method: "POST",
    bodyData: { fdate }
  });
}

export function unsetSprHoliday(fdate) {
  return serverFetch(`sprs/holidays/${fdate}`, {
    method: "DELETE"
  });
}

export function fillSprHolidays(bodyData) {
  return serverFetch("sprs/holidays/fill", {
    method: "POST",
    bodyData
  });
}
